/* Cup & Kind: minimum order quantities + gift box total.
   The minimum itself is server-side (product-qty-input reads custom.minimum_quantity into min="10"),
   so this file only clamps typed values, keeps the "10 boxes: $x" line live, and blocks checkout
   while the cart guard ([data-ck-moq-block]) is on screen. */
(() => {
  if (window.__ckMoq) return;
  window.__ckMoq = true;

  const money = new Intl.NumberFormat("en-CA", { style: "currency", currency: "CAD" });

  const minOf = (input) => parseInt(input.getAttribute("min"), 10) || 0;

  const clamp = (input) => {
    const min = minOf(input);
    if (min <= 1) return;
    const value = parseInt(input.value, 10);
    if (Number.isNaN(value) || value < min) {
      input.value = min;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  const updateTotal = () => {
    const box = document.querySelector(".m-main-product--info [data-ck-moq]");
    const input = document.querySelector(".m-main-product--info .m-quantity__input");
    if (!box || !input) return;
    const qty = Math.max(parseInt(input.value, 10) || 0, parseInt(box.dataset.ckMoq, 10) || 1);
    const unit = parseInt(box.dataset.ckUnit, 10) || 0;
    const line = box.querySelector(".ck-moq__total");
    if (!line) return;
    line.firstChild.textContent = `${qty} boxes: `;
    line.querySelector("[data-ck-total]").textContent = money.format((unit * qty) / 100);
  };

  document.addEventListener("change", (event) => {
    const input = event.target.closest?.(".m-quantity__input");
    if (!input) return;
    clamp(input);
    updateTotal();
  });
  document.addEventListener("focusout", (event) => {
    const input = event.target.closest?.(".m-quantity__input");
    if (input) clamp(input);
  });
  document.addEventListener("click", (event) => {
    if (event.target.closest?.(".m-quantity__button")) requestAnimationFrame(updateTotal);
  });

  /* Checkout guard: footer HTML is re-rendered by the theme on every cart change,
     so we look the notice up at click time instead of caching it. */
  const blocked = (el) => {
    const scope = el.closest("#MinimogCartDrawerFooter, #MinimogCartFooter, form") || document;
    return scope.querySelector("[data-ck-moq-block]") || document.querySelector("[data-ck-moq-block]");
  };
  const stop = (event, notice) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    notice.classList.remove("is-nudged");
    void notice.offsetWidth;
    notice.classList.add("is-nudged");
    notice.scrollIntoView({ block: "nearest", behavior: "smooth" });
  };
  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest?.('[name="checkout"], a[href="/checkout"], a[href*="/checkouts/"]');
      if (!button) return;
      const notice = blocked(button);
      if (notice) stop(event, notice);
    },
    true
  );
  document.addEventListener(
    "submit",
    (event) => {
      const submitter = event.submitter;
      if (!submitter || submitter.name !== "checkout") return;
      const notice = blocked(submitter);
      if (notice) stop(event, notice);
    },
    true
  );

  const init = () => {
    document.querySelectorAll(".m-quantity__input").forEach(clamp);
    updateTotal();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("variant:changed", () => requestAnimationFrame(updateTotal));
})();
